// 通常の領収書発行ウィジェット（data-wu-widget="receipt-issue"）。本体は widget.ts。
//
// 動的 import で読まれる。名前との対応は shared/registry.ts の LOADERS にある。

import { createReceiptWidget } from './widget'

export default createReceiptWidget('order')
